export default {
  // System Notifications
  notifGeoTitle: 'Géolocalisation',
  notifGeoSuccess: 'Signal GPS activé',
  notifGeoError: 'Signal GPS perdu',
  notifDataTitle: 'Connexion de données',
  notifDataSuccess: 'Connecté au réseau internet',
  notifDataError: 'Aucune connection de donnée',
  // map
  search: 'Rechercher',
  settings: 'Paramètres',
  // Welcome
  skip: 'Passer',
  welcomeGeoTxt: 'Atlastories nécessite votre géolocalisation pour découvrir les lieux qui vous entourent',
  welcomeGeoBtn: 'Activer la géolocalisation',
  welcomeUxTxt: 'Connectez vos écouteurs et activer le mode qui tient éveillé votre smartphone pour une meilleure expérience utilisateur',
  welcomeUxBtn: 'Empêcher la mise en veille',
  welcomeGtuTxt: 'Nous utilisons les statistiques pour résoudre les erreurs et améliorer l\'application',
  welcomeGtuBtn: 'Lire conditions générales',
  // Gtu
  agree: 'OK',
  termsTitle: 'Conditions générales d\'utilisation',
  // Settings
  settingsTitle: 'Paramètres',
  settingsLang: 'Langue',
  settingsMap: 'Style de carte',
  settingsGps: 'Fréquence GPS',
  settingsCache: 'Cache des images',
  settingsNosleep: 'Désactiver le veille',
  settingsNosleepEnabled: 'Le téléphone ne se mettra pas en veille',
  settingsNosleepDisabled: 'L\'inactivité mettra en veille le téléphone',
  settingsKm: 'Distances',
  settingsDark: 'Mode sombre',
  settingsTerms: 'Conditions générales',
  settingsCacheFooter: 'Cache des images : XX jour(s)',
  settingsGpsFooter: 'Intervalle: ',
  settingsKmFooter: 'Unité de mesure : ',
  settingsSubtitles: 'Sous-titres',
  enabled: 'Activé',
  disabled: 'Désactivé',
  version: 'Version',
  // SettingsMap
  settingsMapTitle: 'Styles de carte',
  tilesbasic: 'Classique',
  tilesbright: 'Clair',
  tilesdarkmatter: 'Sombre',
  tilespastel: 'Pastel',
  tilestopo: 'Topo',
  tilespositron: 'Gris',
  tileshybrid: 'Satellite',
  tilesstreets: 'Routes',
  tilesvoyager: 'Voyageur',
  // SettingsLang
  settingsLangTitle: 'Langues',
  // Search
  searchPh: 'Chercher un lieu...',
  noResult: 'Aucun résultat',
  footerDiscover: 'Découvrir l\'histoire des lieux',
  footerRead: 'Lire l\'article',
  // Route
  routeTitle: 'Itinéraire',
  rmfoot: 'Piéton',
  rmbike: 'Vélo',
  rmcar: 'Voiture',
  routeLoading: 'Calcul de l\'itinéraire',
  // Geolocation
  geoErrDenied: 'Merci de vérifiez les réglages de votre téléphone pour permettre l\'accès à la géolocalisation',
  geoErrGeneric: 'Votre géolocalisation est nécessaire pour calculer l\'itinéraire',
  geoLoading: 'Geolocalisation en cours',
  geoButton: 'Activer la géolocalisation',
  // Article
  artPlay: 'Lecture',
  artPause: 'Pause',
  artStop: 'Stop',
  artRoute: 'Itinéraire',
  artBookmark: 'Enregistrer',
  // Generic
  close: 'Fermer', // article gallery

  // to remove?
  routeTo: 'Itinéraire vers',
  swiperEmpty: 'Aucun monument dans le coin, bougez la carte !',
  playlistEmpty: 'Rien à écouter pour le moment'
}
